import { render, staticRenderFns } from "./chooseCostCenter.vue?vue&type=template&id=61338021&scoped=true&"
import script from "./chooseCostCenter.vue?vue&type=script&lang=ts&"
export * from "./chooseCostCenter.vue?vue&type=script&lang=ts&"
import style0 from "./chooseCostCenter.vue?vue&type=style&index=0&id=61338021&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61338021",
  null
  
)

export default component.exports